export default "__VITE_ASSET__BXYxI6TR__"